module.exports = __webpack_public_path__ + "static/media/abhay.21bd9a38.png";